// Constant used in select for user type in creation of new user
export const Types = [
  { "value" : "M", "label" : "muirwood"},
  { "value" : "C", "label" : "client"},
  { "value" : "D", "label" : "distributor"},
  { "value" : "O", "label" : "operator"}
];
